var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "col-12",
    attrs: {
      "id": "printManifestContent"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "card-actions",
    staticStyle: {
      "margin-left": "885px",
      "margin-top": "-20px"
    }
  }, [_c('a', {
    on: {
      "click": _vm.callParent
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "style": "font-size:18px"
    }
  })])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('table', {
    staticClass: "table table-bordered mytable12",
    attrs: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "theader"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "tableheader",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('manifestReport.table.title')))])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('manifestReport.table.columns.manifestID')) + ":")]), _vm._v(" " + _vm._s(_vm.listOrderMasterdata.postdatadocumentno))])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('b', [_vm._v(" " + _vm._s(_vm.$t('manifestReport.table.columns.WMSManifestID')) + ":")]), _vm._v(" " + _vm._s(_vm.listOrderMasterdata.id))])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('manifestReport.table.columns.courrierPartner')) + ":")]), _vm._v("  " + _vm._s(_vm.listOrderMasterdata.courier_name))])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('manifestReport.table.columns.courierChannel')) + ":")]), _vm._v(" " + _vm._s(_vm.listOrderMasterdata.channel_name))])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('manifestReport.table.columns.noOfAWB')) + ":")]), _vm._v("  " + _vm._s(_vm.listOrderMasterdata.count))])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('manifestReport.table.columns.vehicleNo')))]), _vm._v(": " + _vm._s(_vm.listOrderMasterdata.vehicle_no))])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('manifestReport.table.columns.handoverPerson')) + ":")]), _vm._v("  " + _vm._s(_vm.listOrderMasterdata.handover_person))])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('manifestReport.table.columns.manifestStatus')) + ":")]), _vm._v(" " + _vm._s(_vm.listOrderMasterdata.manifest_status))])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('manifestReport.table.columns.createdDate')) + ":")]), _vm._v("  " + _vm._s(_vm._f("moment")(_vm.listOrderMasterdata.created_at)))])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('manifestReport.table.columns.handoverDate')) + ":")]), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.listOrderMasterdata.updated_at)))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('div', {
    staticClass: "col-12",
    staticStyle: {
      "overflow": "auto",
      "height": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    attrs: {
      "id": "my-table",
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "theader"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(" #")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.orderNum')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.shipmentId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.awbNo')))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.totalAWBNO), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_c('strong', [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.order_no))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.shipment_id))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.awb_no))])])
  }), _vm._v(" "), ((_vm.totalAWBNO.result && _vm.totalAWBNO.result.length == 0) || _vm.totalAWBNO.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "10",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noRecordFoundMsg')))])]) : _vm._e()], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.signatureLabel')) + ":")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "float": "left"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.courierPerson')) + ":")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "float": "left",
      "margin-left": "50% !important"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.warehousePerson')) + ":")])])])])])])])])], 1), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-bottom": "10px",
      "margin-right": "20px",
      "float": "right"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.print(_vm.listOrderMasterdata.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" " + _vm._s(_vm.$t('common.print')))])])])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-62759b1e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62759b1e","hasScoped":true}!./src/views/components/manifestdetails/printmanifestdetails.component.html
// module id = 1738
// module chunks = 0